import { VueModule } from '@Foundation/utilities';
import NewsletterSticky from './code/Scripts/components/newsletter-sticky';

export default VueModule({
  components: {
    NewsletterSticky,
  },
});
